import React, {ReactNode} from "react";
import {styled} from "@reside/ui";

import {UseScrollSpy} from "../../../../hooks/useScrollSpy";

export const FACILITY_SETTINGS_SCROLL_CONTAINER =
  ".js-facility-settings-scroll-container";

export const FACILITY_SETTINGS_SCROLL_CONTAINER_CLASS =
  "js-facility-settings-scroll-container";

type Props = Readonly<{
  id: string;
  children: ReactNode;
}>;

type ScrollTargetProps = Readonly<{
  id: string;
  children: ReactNode;
}>;

/** Scroll-spy anchor for in-section nav items (no section divider). */
export const FacilitySettingsScrollTarget = ({id, children}: ScrollTargetProps) => (
  <UseScrollSpy
    id={id}
    scrollContainerSelector={FACILITY_SETTINGS_SCROLL_CONTAINER}
    threshold={0}
    rootMargin="-10% 0px -55% 0px"
  >
    {({scrollSpyRef}) => (
      <ScrollTarget ref={scrollSpyRef} id={id}>
        {children}
      </ScrollTarget>
    )}
  </UseScrollSpy>
);

export const SECTION_GENERAL = "__general";

export const FacilitySettingsSection = ({id, children}: Props) => (
  <UseScrollSpy
    id={id}
    scrollContainerSelector={FACILITY_SETTINGS_SCROLL_CONTAINER}
    threshold={0}
    rootMargin="-10% 0px -55% 0px"
  >
    {({scrollSpyRef}) => (
      <Section ref={scrollSpyRef} id={id}>
        {children}
      </Section>
    )}
  </UseScrollSpy>
);

const ScrollTarget = styled.div`
  scroll-margin-top: 24px;
`;

const Section = styled.section`
  scroll-margin-top: 24px;

  & + & {
    margin-top: 48px;
    padding-top: 48px;
    border-top: 1px solid ${({theme}) => theme.color.borderGray};
  }
`;
